class OpenPopUps {
  constructor() {
    document.querySelectorAll('.open-popup').forEach(item => {
      item.addEventListener('click', (e) => {
        let name_popup = item.getAttribute('data-name-popup');
        const popup = document.getElementById(name_popup);
        if (popup) {
          const link = popup.querySelector('a');
          if (link) {
            link.click();
            e.stopPropagation(); 
          } 
        }
      });
    });
  }
}

export default OpenPopUps;